<template>
  <v-dialog
    retain-focus
    :value="create"
    v-on:click:outside="$router.push('/product')"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title tabindex="-1">
        <span class="headline">Create Product</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="
            () => {
              this['Product/fetchProducts']({ page: this.page });
              $router.push('/product');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form width="100%" ref="createForm" v-model="createValid">
          <v-text-field
            label="Product Name*"
            v-model="createFields.name"
            :rules="validationRules.name"
            :error-messages="inputErrorMessages('name')"
            name="name"
            ref="name"
          ></v-text-field>
          <v-text-field
            label="Product Price*"
            v-model="createFields.price"
            :rules="validationRules.price"
            :error-messages="inputErrorMessages('price')"
            name="price"
          ></v-text-field>
          <v-textarea
            v-model="createFields.description"
            label="Product Description*"
            :rules="validationRules.description"
            :error-messages="inputErrorMessages('description')"
            counter="255"
            name="description"
          ></v-textarea>
          <v-select
            v-model="createFields.supplier_id"
            :rules="validationRules.supplier_id"
            :items="suppliers"
            item-text="company_name"
            item-value="id"
            label="Supplier"
            name="supplier_id"
            :error-messages="inputErrorMessages('supplier_id')"
          ></v-select>
          <!--<v-text-field
            v-if="!!createFields.supplier_id"
            :rules="validationRules.supplier_code"
            label="Supplier Product Code"
            v-model="createFields.supplier_code"
            name="supplier_code"
            :error-messages="inputErrorMessages('supplier_code')"
          ></v-text-field>-->
          <v-select
            :rules="validationRules.product_type_id"
            v-model="createFields.product_type_id"
            :items="productTypes"
            item-text="name"
            item-value="id"
            label="Product Type*"
            name="product_type_id"
            :error-messages="inputErrorMessages('product_type_id')"
          ></v-select>
          <v-file-input
            chips
            multiple
            label="Upload sketches/illustration"
            v-model="createFields.files"
            name="files[]"
            :error-messages="inputErrorMessages('files')"
          ></v-file-input>

          <v-select
            v-model="createFields.karat"
            :items="karats"
            item-text="name"
            item-value="name"
            label="Karat"
            name="karat"
            :rules="validationRules.karat"
            :error-messages="inputErrorMessages('karat')"
          ></v-select>

          <v-text-field
            label="Item Weight"
            v-model="createFields.item_weight"
            :rules="validationRules.item_weight"
            :error-messages="inputErrorMessages('item_weight')"
            name="item_weight"
          ></v-text-field>

          <v-text-field
            label="Rate/Gram"
            v-model="createFields.rate_gram"
            :rules="validationRules.rate_gram"
            :error-messages="inputErrorMessages('rate_gram')"
            name="rate_gram"
          ></v-text-field>

          <v-text-field
            label="Measurement"
            v-model="createFields.measurement"
            :rules="validationRules.measurement"
            :error-messages="inputErrorMessages('measurement')"
            name="measurement"
          ></v-text-field>

          <v-select
            v-model="createFields.gold_classification"
            :items="goldClassifications"
            item-text="name"
            item-value="name"
            label="Classification of Gold"
            name="gold_classification"
            :rules="validationRules.gold_classification"
            :error-messages="inputErrorMessages('gold_classification')"
          ></v-select>

          <v-text-field
            v-if="createFields.gold_classification == 'Others'"
            v-model="createFields.other_gold_classification"
            :rules="validationRules.other_gold_classification"
            :error-messages="inputErrorMessages('other_gold_classification')"
            name="other_gold_classification"
          ></v-text-field>

          <v-text-field
            label="No. of Diamonds"
            v-model="createFields.no_of_diamond"
            :rules="validationRules.no_of_diamond"
            :error-messages="inputErrorMessages('no_of_diamond')"
            name="no_of_diamond"
          ></v-text-field>

          <v-list subheader>
            <v-subheader class="d-block" style="padding: 0; height: auto;"
              >Specification
              <span
                class="red--text d-block"
                v-bind:key="index"
                v-for="(message, index) in inputErrorMessages('meta')"
                >{{ message }}</span
              >
            </v-subheader>
            <v-list-item
              style="padding: 0;"
              v-for="(spec, index) in createFields.meta"
              v-bind:key="index"
            >
              <v-list-item-content>
                <v-text-field dense :label="spec.specName" v-model="spec.value"></v-text-field>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon color="primary" @click="removeSpec(index)">close</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item style="padding: 0;">
              <v-list-item-content>
                <v-text-field
                  dense
                  label="New Spec name"
                  v-model="createFields.newSpec.name"
                  :error-messages="addSpecError"
                ></v-text-field>
                <v-text-field
                  dense
                  label="New Spec value"
                  v-model="createFields.newSpec.value"
                ></v-text-field>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon
                  color="primary"
                  @click="addSpec(createFields.newSpec.name, createFields.newSpec.value)"
                  >mdi-plus</v-icon
                >
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="
            $router.push('/product');
            clearCreate();
          "
          >Cancel</v-btn
        >
        <v-btn color="blue darken-1" text @click="saveProduct">Save</v-btn>
        <v-switch v-model="continousCreation" label="Continuous Create"></v-switch>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      addSpecError: undefined,
      continousCreation: false,
      createValid: true,
      validationRules: {
        name: [
          v => !!v || this.rem('Product name'),
          v => v.length <= 255 || 'Product name should not be greater than 255'
        ],
        description: [
          v => !!v || this.rem('Description'),
          v => v.length <= 255 || 'Description should not be greater than 255'
        ],
        price: [
          v => !!v || this.rem('Price'),
          v => (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'Price should be a number',
          v => v > 0 || 'Price should be greater than 0'
        ],
        supplier_id: [v => !!v || this.rem('Supplier')],
        product_type_id: [v => !!v || this.rem('Product Type')]
        //supplier_code: [v => (v.supplier_id != '' && v != '') || 'Supplier Code is required']
      },
      errorMessages: {},
      createFields: {
        price: 0,
        files: undefined,
        name: '',
        description: '',
        price: 0,
        supplier_id: undefined,
        //supplier_code: '',
        product_type_id: undefined,
        clasification: 0,
        karat: '',
        item_weight: '',
        rate_gram: '',
        measurement: '',
        gold_classification: '',
        other_gold_classification: '',
        no_of_diamond: '',
        meta: [],
        newSpec: {
          name: '',
          value: ''
        }
      }
    };
  },
  computed: {
    ...mapState({
      suppliers: state => state.Supplier.plainsuppliers,
      productTypes: state => state.ProductType.plainproductTypes,
      classifications: state => state.Classification.classifications,
      karats: state => state.Karat.karats,
      goldClassifications: state => state.GoldClassification.goldClassifications
    })
  },
  mounted() {
    this['Supplier/fetchSuppliers']({ dontPaginate: false });
    this['ProductType/fetchProductTypes']({ dontPaginate: false });
  },
  props: {
    create: false,
    page: 0
  },
  methods: {
    ...mapActions([
      'Supplier/fetchSuppliers',
      'ProductType/fetchProductTypes',
      'Product/fetchProducts'
    ]),
    clearCreate() {
      this.createFields = {
        price: 0,
        files: undefined,
        name: '',
        description: '',
        price: 0,
        supplier_id: undefined,
        //supplier_code: '',
        product_type_id: undefined,
        clasification: 0,
        karat: '',
        item_weight: '',
        rate_gram: '',
        measurement: '',
        gold_classification: '',
        other_gold_classification: '',
        no_of_diamond: '',
        meta: [
          {
            specName: 'size',
            value: 20
          },
          {
            specName: 'weight',
            value: 100
          }
        ],
        newSpec: {
          name: '',
          value: ''
        }
      };
      this.$refs.createForm.resetValidation();
    },
    rem(name) {
      return `${name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveProduct() {
      if (1 == 1 || this.$refs.createForm.validate()) {
        const formData = new FormData(this.$refs.createForm.$el);
        formData.append('meta', JSON.stringify(this.createFields.meta));
        formData.append('supplier_id', this.createFields.supplier_id);
        formData.append('product_type_id', this.createFields.product_type_id);
        formData.append('karat', this.createFields.karat);
        formData.append('gold_classification', this.createFields.gold_classification);
        axios
          .post('api/v1/product', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Product created successfully...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.createForm.resetValidation();
            this['Product/fetchProducts']({ page: this.page });
            this.clearCreate();
            if (this.continousCreation === false) {
              this.$router.push('/product');
            }
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {});
      }
    },
    removeSpec(index) {
      this.createFields.meta.splice(index, 1);
    },
    addSpec(name, value) {
      if (!!name.trim()) {
        this.createFields.meta.push({
          specName: name,
          value: value
        });
        this.addSpecError = undefined;
      } else {
        this.addSpecError = [this.rem('Specification Name')];
      }
    }
  }
};
</script>